import form from "./form";
import selector from "./selector";
import viewer from "./viewer";

export default {
    form,
    selector,
    viewer,
}